import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	color: ${CSSVars.white};
	text-align: center;
	position: relative;

	p {
		color: ${CSSVars.primary500};
		font-weight: 600;
		font-size: ${CSSVars.fontSizeMD};
		text-transform: uppercase;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	h2 {
		font-weight: 600;
		font-size: ${CSSVars.fontSize4XL};
		margin: 30px 0 50px;
		font-size: ${CSSVars.fontSize2XL};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.platforms-container {
		margin-top: 50px;
		display: grid;

		grid-gap: 50px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		grid-auto-rows: minmax(auto, 150px);

		.platform-card {
			background-color: ${CSSVars.gray600};
			display: flex;
			justify-content: center;
			padding: 50px;
			border-radius: 10px;
			transition: 0.2s;
			border: 1px solid #2a2e42;

			&:hover {
				border: 1px solid ${CSSVars.gray500};
			}

			.img-wrapper {
				img {
					max-width: 100%;
					height: 100%;
					object-fit: contain;
					position: relative !important;
				}
			}
		}
	}
`;
